import React from 'react';

import type { AlternatePage, PageLanguage } from 'src/components/common/page-context';
import { DEFAULT_CLUB_ID } from 'src/content/constants';
import { BuildType } from 'src/enums/build/build-type';
import { Language } from 'src/enums/language';
import type { PAGE_LEVEL } from 'src/enums/page-level';

import { getBuildTypesFlags } from './site-context-helper';
import type { Styling } from './styling';
import { defaultStyling } from './styling';

export type SiteConfig = {
  siteId: string;
  isGlobalPage: boolean;
  language: Language;
  pageLanguages?: PageLanguage[];
  alternatePages?: AlternatePage[];
  buildType: BuildType;
  isMeridian: boolean;
  isHarbour: boolean;
  isDL: boolean;
  styling: Styling;
  inlineImageData?: Record<string, string>; // Note: this will only be defined when client-side.
  basePath: string;
  untranslatedPath?: string;
  pageLevel: PAGE_LEVEL | undefined;
  seo: {
    allowPageIndex: boolean | undefined;
    title?: string;
    description?: string;
  };
};

export const SiteContext = React.createContext<SiteConfig>({
  siteId: DEFAULT_CLUB_ID,
  isGlobalPage: false,
  language: Language.EN_GB,
  buildType: BuildType.DAVID_LLOYD_UK,
  ...getBuildTypesFlags(BuildType.DAVID_LLOYD_UK),
  styling: defaultStyling,
  basePath: '/',
  untranslatedPath: '/',
  pageLevel: undefined,
  seo: {
    allowPageIndex: undefined,
  },
});
